import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-card-border mt-4 shrink-0 safe-area-bottom">
      <div className="max-w-[1320px] mx-auto px-4 sm:px-6 py-4 sm:py-0 sm:h-16 flex items-center">
        <div className="flex flex-col sm:flex-row items-center sm:justify-between w-full gap-2 sm:gap-0">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-sm font-bold text-gray-700 dark:text-foreground">SteamDeal</span>
          </Link>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-400 dark:text-muted">개인정보처리방침</span>
            <span className="text-xs text-gray-400 dark:text-muted">이용약관</span>
            <span className="text-xs text-gray-400 dark:text-muted">소개</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
